import { request } from '@/utils'

export default {
  getEmptyQuery: () => {
    return {
      storeId: null,
      brandSuccessionModel: null,
      keyword: null,
      goodsCategory: '',
      hasStore: null,
      typeId: null,
      brand: null,
    }
  },
  getEmptyDetailQuery: (categoryId: string) => {
    return {
      categoryId,
      goodsStatus: null,
      keyword: null,
      storehouseId: null,
      type: [],
      goodsCategory: '',
    }
  },
  getEmptyInbound: () => {
    return {
      categoryId: null,
      count: 1,
      countUnit: null,
      files: [],
      fromResourceCode: 'xmth',
      goodsCode: null,
      goodsStatus: null,
      projectId: null,
      storehouseId: null,

      belongInstanceId: null,
      belongReturnGoods: [
        {
          categoryId: null,
          returnCount: null,
          goodsStatus: null,
          storehouseId: null,
        },
      ],
    }
  },
  getEmptyOutbound: (categoryId: string) => {
    return {
      applyUserId: null,
      categoryId,
      companyDept: null,
      goodsIds: [],
      goodsCodes: [],
      parterId: null,
      projectId: null,
      reasonCode: null,
      receiveUserId: null,
      summary: null,
    }
  },
  // 库存分页
  getStockByPage: (params: PageParams) =>
    request.post(`/warehouse/stockManage/list?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`, params.body || {}),
  getGiftStockByPage: (params: PageParams) =>
    request.post(`/warehouse/stockManage/listGift?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`, params.body || {}),
  getSuppliesStockByPage: (params: PageParams) =>
    request.post(`/warehouse/stockManage/listSupplies?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`, params.body || {}),
  stockWithCategoryList: (params: PageParams) =>
    request.post(
      `/warehouse/stockManage/stockWithCategoryList?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`,
      params.body || {}
    ),
  // 品牌系列型号
  getBrandSeriesModelList: () => request.get('/purchase/purchase/supply/service/type/brandCascadeQuery'),
  getCategoryCascade: () => request.get('/purchase/purchase/supply/service/type/categoryCascadeQuery'),
  // 导出库存管理列表
  exportExcel: (data: Recordable) => request.post('/warehouse/stockManage/exportExcel', data, { responseType: 'blob' }),
  exportExcelGift: (data: Recordable) => request.post('/warehouse/stockManage/exportExcelGift', data, { responseType: 'blob' }),
  exportExcelSupplies: (data: Recordable) => request.post('/warehouse/stockManage/exportExcelSupplies', data, { responseType: 'blob' }),
  // 库存详情分页
  getCategoryStockByPage: (params: PageParams) =>
    request.post(
      `/warehouse/stockManage/listGoodsByCategoryId?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`,
      params.body || {}
    ),
  getGiftCategoryStockByPage: (params: PageParams) =>
    request.post(
      `/warehouse/stockManage/listGiftGoodsByCategoryId?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`,
      params.body || {}
    ),
  getSuppliesCategoryStockByPage: (params: PageParams) =>
    request.post(
      `/warehouse/stockManage/listSuppliesGoodsByCategoryId?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`,
      params.body || {}
    ),
  // 库存详情分页
  getCategoryStockByIds: (categoryId: string, ids: Array<string>, goodsCategory) =>
    request.post(`/warehouse/stockManage/getGoodsInfoRowByGoodsId?categoryId=${categoryId}&goodsCategory=${goodsCategory}`, ids),
  // 仓库列表
  getStockFormList: () => request.get('/warehouse/storehouse/getFormList'),
  // 新增入库
  addGoodsIn: (data: Recordable) => request.post('/warehouse/stockManage/addGoodsIn', data),
  // 批量新增入库
  addGoodsInBatch: (data: Recordable) => request.post('/warehouse/stockManage/addGoodsInBatch', data),
  // 新增出库
  addGoodsOut: (data: Recordable) => request.post('/warehouse/stockManage/addGoodsOut', data),
  // 根据货品编码获取货品信息
  getCategoryInfoByCode: (code: string) => request.get(`/warehouse/stockManage/getGoodsInfoByGoodsCode/${code}`),
  // 根据货品id获取货品信息
  getGoodsInfoById: (id: string) => request.get(`/warehouse/stockManage/getGoodsInfo/${id}`),
  // 修改货品信息
  updateGoodsInfo: (data: Recordable) => request.post('/warehouse/stockManage/saveGoodsInfo', data),
  // 获取所有供货商
  getAllPartner: () => request.get('/warehouse/stockManage/getAllPartner'),
  // 根据货品获取货品颜色
  getCategoryColors: (categoryId: string) => request.get(`/purchase/purchase/categoryV2/getCategoryColors?categoryId=${categoryId}`),
  // 调拨
  sureTransfer: (data: any) => request.post(`/warehouse/storeTransfer/sureTransfer`, data),
  getProjectFormSelectListForDomain: () => request.get('/project/project/open/getProjectFormSelectListForDomain'),
  getCustomerCompanySelectDownByProjectId: (projectId: string) =>
    request.get(`/project/project/open/getCustomerCompanySelectDownByProjectId?projectId=${projectId}`),
  getrCustomerContactUser: (customerOrgId: string) =>
    request.get(`/project/project/open/getrCustomerContactUser?customerOrgId=${customerOrgId}`),
  getCustomerContactUserOnProjectId: (customerOrgId: string, projectId: string) =>
    request.get(`/project/project/open/getCustomerContactUserOnProjectId?customerOrgId=${customerOrgId}&projectId=${projectId}`),
  // 保存领用申请
  saveBelong: (data: any) => request.post('/warehouse/goodsBelong/saveBelong', data),
  // 保存礼品领用申请
  saveGiftBelong: (data: any) => request.post('/warehouse/goodsBelong/saveGiftBelong', data),
  changeBelong: (data: any) => request.post('/warehouse/goodsBelong/changeBelong', data),
  getBelongUserId: (stockId: string) => request.get(`/warehouse/goodsBelong/getBelongUserId?stockId=${stockId}`),
  // 查询变更列表
  changePageList: (data: any) => request.post('/warehouse/goodsBelong/changePageList', data.body),
  saveBorrow: (data: any) => request.post('/warehouse/goodsBorrow/saveBorrow', data),
  getSelectOfErpProcess: (bussCode: any) => request.get(`/workflow/wflow/erp/process/task/getSelectOfErpProcess?bussCode=${bussCode}`),
  listByInstanceId: (instanceId: any) => request.post(`/warehouse/goodsBelong/listByInstanceId?instanceId=${instanceId}`),
  sureBelongGoodsIn: (data: any) => request.post('/warehouse/inGoods/sureBelongGoodsIn', data),
  sureGiftBelongGoodsIn: (data: any) => request.post('/warehouse/inGoods/sureGiftBelongGoodsIn', data),
  getAllType: (type: string) => request.get(`/purchase/purchase/materials/getAllType?goodsCategory=${type}`),
  getAllBrand: (type: string) => request.get(`/purchase/purchase/materials/getAllBrand?goodsCategory=${type}`),
  getFileBrowseUrl: (id: string, type?: string) => request.get(`/warehouse/stockManage/getFileBrowseUrl?id=${id}&type=${type}`),
  getBrowseDetail: (id: string) => request.get(`/warehouse/stockManage/getBrowseDetail?id=${id}`),
}
